import { render } from "./RequirementDocumentsView.vue?vue&type=template&id=98c167b4&scoped=true"
import script from "./RequirementDocumentsView.vue?vue&type=script&lang=js"
export * from "./RequirementDocumentsView.vue?vue&type=script&lang=js"

import "./RequirementDocumentsView.vue?vue&type=style&index=0&id=98c167b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c167b4"]])

export default __exports__